import {
  getFirstAttributeValue,
  isInStock,
  type Product,
  type Variant,
} from '@scayle/storefront-nuxt'

export type VariantSize = {
  variantId: number
  label: string
  value?: string
  isAvailable: boolean
  [key: string]: unknown
}

export const getVariantSizes = (variants?: Variant[]) => {
  return [...(variants || [])]
    .filter((variant) => {
      return variant.attributes && Object.keys(variant.attributes).length > 0
    })
    .sort((a, b) => {
      const left = getFirstAttributeValue(a.attributes, 'sort')?.value
      const right = getFirstAttributeValue(b.attributes, 'sort')?.value

      if (!left || !right) {
        return 0
      }
      return parseInt(left, 10) < parseInt(right, 10) ? -1 : 1
    })
    .map((variant) => {
      const size = getFirstAttributeValue(variant.attributes, 'size')

      return {
        variantId: variant.id,
        label: size!.label,
        value: size!.value,
        isAvailable: isInStock(variant),
      }
    })
}

export const hasOneSizeProductVariantOnly = ({ variants }: Product) => {
  const hasOneVariant = variants?.length === 1
  if (!hasOneVariant) {
    return false
  }
  const sizeAttribute = getAttributeValue(variants[0].attributes, 'size')
  return sizeAttribute === ONE_SIZE_KEY
}
